var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{class:{active: _vm.header.menuActive === _vm.name, disabled: _vm.disabled},attrs:{"tag":"a","to":_vm.routeData}},[_c('div',{staticClass:"micon"},[_c('i',{class:_vm.icon})]),_c('span',{staticClass:"lbl"},[_vm._v(_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }